import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader";
import { type FC, Suspense, lazy } from "react";

const EmailPhoneUpdatePage = lazy(() => import("./EmailPhoneUpdatePage"));

const EmailPhoneUpdatePageLazy: FC = () => {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <EmailPhoneUpdatePage />
    </Suspense>
  );
};

export default EmailPhoneUpdatePageLazy;
